import React, { Component } from "react";
import Button from "pages/_components/Button";
import { func, string, bool } from "prop-types";
import classNames from "classnames";

class CameraButton extends Component {
    static propTypes = {
        id: string,
        loading: bool,
        handleClick: func.isRequired,
        selfie: bool,
        className: string,
    };

    static defaultProps = {
        id: "cameraBtn",
        loading: false,
        selfie: false,
        className: "",
    };

    handleClick = () => {
        const { handleClick } = this.props;

        if (handleClick) {
            handleClick();
        }
    };

    render() {
        const { id, selfie, loading, className } = this.props;

        return (
            <Button
                bsStyle="primary"
                className={classNames("btn-picture", className, { "selfie-btn": selfie })}
                loading={loading}
                id={id}
                onClick={this.handleClick}
                defaultLabelText="Scan"
                block
            />
        );
    }
}

export default CameraButton;
